// src/components/home/PricingSection.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PricingSection.css';

const PricingSection = () => {
  const navigate = useNavigate();

  return (
    <section className="pricing-section" id="pricing">
      <div className="pricing-container">
        <div className="section-header">
          <span className="section-badge">Simple Pricing</span>
          <h2 className="section-title">One Simple Price. No Hidden Fees.</h2>
          <p className="section-subtitle">
            Start with a 14-day free trial. No credit card required. Cancel anytime.
          </p>
        </div>

        <div className="pricing-card">
          <div className="pricing-header">
            <h3 className="pricing-title">Professional Plan</h3>
            <p className="pricing-subtitle">Everything you need to grow your practice</p>
          </div>

          <div className="pricing-price">
            <div className="price-amount">
              <span className="currency">$</span>
              <span className="amount">197</span>
              <span className="period">/month</span>
            </div>
            <p className="price-note">After 14-day free trial</p>
          </div>

          <div className="pricing-features">
            <h4 className="features-title">What's Included:</h4>
            <ul className="features-list">
              <li>
                <span className="check-icon">✓</span>
                <span>Unlimited online bookings 24/7</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Real-time sync with Open Dental</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Custom booking page with your branding</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Automated SMS & email reminders</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Patient reviews & reputation management</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Insurance verification integration</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Analytics & reporting dashboard</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Mobile-optimized for all devices</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>HIPAA compliant & secure</span>
              </li>
              <li>
                <span className="check-icon">✓</span>
                <span>Dedicated customer support</span>
              </li>
            </ul>
          </div>

          <div className="pricing-cta">
            <button 
              onClick={() => navigate('/register')} 
              className="btn-primary-large"
            >
              Start 14-Day Free Trial
            </button>
            <p className="cta-note">No credit card required • Cancel anytime</p>
          </div>
        </div>

        <div className="pricing-faq">
          <h4 className="faq-title">Common Questions</h4>
          <div className="faq-grid">
            <div className="faq-item">
              <h5>Do I need a credit card for the trial?</h5>
              <p>No! Start your 14-day trial with no credit card required. Only add payment details if you decide to continue after the trial.</p>
            </div>
            <div className="faq-item">
              <h5>Can I cancel anytime?</h5>
              <p>Absolutely. Cancel anytime with no penalties or long-term contracts. We believe in earning your business every month.</p>
            </div>
            <div className="faq-item">
              <h5>Are there setup fees?</h5>
              <p>No setup fees, no installation costs, no hidden charges. Just $197/month after your free trial ends.</p>
            </div>
            <div className="faq-item">
              <h5>What happens after the trial?</h5>
              <p>After 14 days, you'll be billed $197/month. You can cancel before the trial ends with no charges whatsoever.</p>
            </div>
          </div>
        </div>

        <div className="pricing-guarantee">
          <div className="guarantee-icon">🛡️</div>
          <h4>30-Day Money-Back Guarantee</h4>
          <p>Not satisfied? Get a full refund within 30 days of your first payment—no questions asked.</p>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;